export default {
    setFirstName: (state, firstName) => state.firstName = firstName,
    setLastName: (state, lastName) => state.lastName = lastName,
    setEmail: (state, email) => state.email = email,
    setPhone: (state, phone) => state.phone = phone,
    setCompanyName: (state, companyName) => state.companyName = companyName,
    setFleetSize: (state, fleetSize) => state.fleetSize = fleetSize,
    setState: (state, payload) => state.state = payload,
    setCountry: (state, country) => state.country = country,
}